import React, { Component } from "react";
import Autocomplete from "react-autocomplete";

class MovieInput extends Component {
  render() {
    if (this.props.focus) {
      this.input.focus();
    }

    return (
      <div className="movie-input input-container autocomplete">
        <Autocomplete
          ref={ref => this.input = ref}
          getItemValue={item => item.title}
          items={this.props.movies}
          renderItem={(item, isHighlighted) => (
            <div
              key={item.title}
              className="suggestion"
              style={{ background: isHighlighted ? "lightgray" : "white" }}
            >
              {item.title}
            </div>
          )}
          autoHighlight={true}
          inputProps={{
            tabIndex: this.props.tabIndex,
            placeholder: "e.g. Deadpool 2",
            onBlur: e => {
              if (this.props.movies.length > 0) {
                this.props.selectMovie(this.props.movies[0], false);
              }
            }
          }}
          value={this.props.value}
          onChange={e => this.props.onChange(e.target.value)}
          onSelect={(val, item) => this.props.selectMovie(item, true)}
        />
      </div>
    );
  }
}

export default MovieInput;



// WEBPACK FOOTER //
// ./src/components/MovieInput.js